import { clamp } from "../lib/utils";

export function ProgressBar({ value, label, compact = false }: { value: number; label?: string; compact?: boolean }) {
  const safeValue = clamp(value);
  return (
    <div className={`progress-wrap ${compact ? "progress-compact" : ""}`}>
      {label && <div className="progress-label"><span>{label}</span><strong>{safeValue}%</strong></div>}
      <div className="progress-track" role="progressbar" aria-valuenow={safeValue} aria-valuemin={0} aria-valuemax={100} aria-label={label || "Course progress"}>
        <span style={{ width: `${safeValue}%` }} />
      </div>
    </div>
  );
}
